import React from 'react';
import './style.scss';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { DateInput, DateInputProps } from 'views/mutual/dateInput';
import { formatPrice } from 'views/utils/converter';
import { LabelValueUnitSelector } from 'views/templates/module/unitSelector';
import { Spinbox } from 'views/mutual/spinbox';
import { useLotInputAmountControl } from '../hooks';
import { SimpleTooltip } from 'views/mutual/tooltip';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { findIcon, IconName } from 'utils/handleIcon';

type LeaseFundLotInputProps = {
  interest: number | null;
  accruedInterest?: string | null;
  totalAmountRaw: number | null;
  disabled: boolean | undefined;
  error: string | undefined;
  onChange: ((value: string) => void) | undefined;
  value: number | null | undefined;
  amountOptionsRaw: Array<string | number>;
  step?: number | null;
  maxQuantity?: number | null;
  dateInputProps: DateInputProps;
};

export const LotInput_LeaseFund = (props: LeaseFundLotInputProps) => {
  const { amountProps } = useLotInputAmountControl({
    disabled: props.disabled,
    error: props.error,
    onChange: props.onChange,
    currentAmount: props.value,
    amountOptionsRaw: props.amountOptionsRaw,
    step: props.step!,
    maxQuantity: props.maxQuantity!,
    unit: '円',
  });
  const selectedAmount = amountProps.unitSelectorProps.selectedOption
    ? Number(amountProps.unitSelectorProps.selectedOption.replaceAll(',', ''))
    : null;
  const displayAmount = amountProps.showManualQuantity
    ? (amountProps.spinboxProps.value ?? null)
    : selectedAmount;

  return (
    <div className="lotInput lotInputLeaseFund">
      <div className="lotInput_header">申込金額</div>
      <div className="lotInput_body lotInputLeaseFund_body">
        <div className="overview">
          <div className="overview_inputField">
            <span>{'申込金額：'}</span>
            <LabelValueUnitSelector {...amountProps.unitSelectorProps} />
          </div>
          <div className="overview_inputField">
            {amountProps.showManualQuantity && (
              <>
                <span>{'手入力（円）：'}</span>
                <Spinbox {...amountProps.spinboxProps} unitPosition="right_6rem" />
              </>
            )}
          </div>
        </div>
        <div className="lotInputLeaseFund_body_input">
          <div className="lotInputLeaseFund_body_input_header">出資金額</div>
          <div className="lotInputLeaseFund_body_input_value">
            {displayAmount !== null ? formatPrice(displayAmount) : ''}
          </div>
          <div className="lotInputLeaseFund_body_input_unit">円</div>
        </div>
        <DateInput {...props.dateInputProps} />
        <Description
          label={
            <>
              ※振込が完了する日（期日）をご指定ください。
              <br />
              　指定された期日までに着金が確認できない場合は、ご出資いただけない可能性がございます。
            </>
          }
          labelColor={labelColor.red}
          labelSize={labelSize.small}
        />
        <div className="lotInputLeaseFund_body_interest">
          <div className='lotInputLeaseFund_body_interest_tooltip'>
            <span>{'経過利息'}</span>
            <SimpleTooltip triggerText={<SvgIcon icon={findIcon(IconName.help)} size={IconSize.icon_xs} />} description={props.accruedInterest ?? ''} />            
          </div>
          {formatPrice(props.interest)}
        </div>
        <span className="lotInputLeaseFund_body_total">{formatPrice(props.totalAmountRaw)}</span>
        <Description
          label="※申込金額は、10,000,000円単位でご入力ください。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
        <Description
          label="※経過利息及び譲渡代金総額は、振込予定日までにご入金いただく場合の金額を表示しています。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
        <Description
          label="※お申込日時点によって、選択できる振込予定日を制限させて頂いております。"
          labelColor={labelColor.gray}
          labelSize={labelSize.small}
        />
      </div>
    </div>
  );
};
